import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from './features/authentication/PrivateRoute';

const createRoutes = routeConfig => {
    const publicRoutes = [];
    const privateRoutes = [];
    const allRoutes = []; // original paths '/account/:ref/overview' etc

    let i = 0;

    const pushRoute = (item, path) => {
        i++; // eslint-disable-line
        const cleanPath = path.replace(/\/+/, '/').replace(/^\^\/$/, '');
        const RouteComp = item.isPublic ? Route : PrivateRoute;
        const route = (
            <RouteComp key={`key-${i}`} component={item.component} path={cleanPath} exact={cleanPath === '/'} />
        );

        allRoutes.push({ path: cleanPath, name: item.name });

        if (item.isPublic) {
            publicRoutes.push(route);
        } else {
            privateRoutes.push(route);
        }
    };

    const parseRoutes = (item, parentPath = '/') => {
        if (item.component && item.component.name !== 'App') {
            pushRoute(item, `${parentPath}/${item.path}`);
        }
        if (item.childRoutes) {
            item.childRoutes.forEach(childItem => {
                parseRoutes(childItem, `${parentPath}/${item.path}`);
            });
        }
    };

    routeConfig.forEach(item => {
        parseRoutes(item);
    });

    return {
        publicRoutes,
        privateRoutes,
        allRoutes,
    };
};

export default createRoutes;
